import axios from 'axios';

import settings from 'settings';
import { clearAuthTokens, getAccessToken, getRefreshToken, setAuthTokens } from './authTokens';

const httpClient = axios.create();

let refreshRequest: Promise<string | null> | null = null;

httpClient.interceptors.request.use((config) => {
  const accessToken = getAccessToken();
  const headers = config.headers || {};

  if (accessToken && !headers.Authorization && !headers.authorization) {
    config.headers = {
      ...headers,
      Authorization: `Bearer ${accessToken}`,
    };
  }

  return config;
});

httpClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config || {};
    const refreshToken = getRefreshToken();

    if (
      error.response?.status === 401 &&
      refreshToken &&
      !originalRequest._retry &&
      !String(originalRequest.url || '').includes('/auth/token/')
    ) {
      originalRequest._retry = true;

      if (!refreshRequest) {
        refreshRequest = axios
          .post(`${settings.API_URL}/auth/token/refresh/`, { refresh: refreshToken })
          .then(({ data }) => {
            setAuthTokens({
              access: data.access,
              refresh: data.refresh || refreshToken,
            });
            return data.access as string;
          })
          .catch((refreshError) => {
            clearAuthTokens();
            throw refreshError;
          })
          .finally(() => {
            refreshRequest = null;
          });
      }

      const accessToken = await refreshRequest;

      if (accessToken) {
        originalRequest.headers = {
          ...(originalRequest.headers || {}),
          Authorization: `Bearer ${accessToken}`,
        };
        return httpClient(originalRequest);
      }
    }

    return Promise.reject(error);
  }
);

export default httpClient;
